import {
  initialState,
  Actions,
  State,
  NEW_RESPONSIBLE,
  NEW_RESPONSIBLE_SUCCESS,
  NEW_RESPONSIBLE_ERROR,
  RESET_NEW_RESPONSIBLE,
} from '../../types/responsible/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_RESPONSIBLE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_RESPONSIBLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_RESPONSIBLE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_RESPONSIBLE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
